import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

import styles from '../../helpers/snazzymaps';

const LocationMap = ({
  mapLat,
  mapLng,
  address,
  getDirectionsLabel,
  apiKey,
  mapUrl,
  geocodeUrl
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey
  });

  const [status, setStatus] = useState();
  const [mapData, setMapData] = useState();

  useEffect(() => {
    const fetchFeed = async () => {
      try {
        const {
          data: { results },
          status
        } = await Axios({
          method: 'GET',
          url: geocodeUrl,
          params: {
            key: apiKey,
            address: address?.trim() ? address.trim() : null,
            latlng: mapLat && mapLng ? `${mapLat},${mapLng}` : null
          }
        });
        console.log(results);

        setMapData(results[0]);
        setStatus(status);
      } catch (e) {
        console.log('Error fetching map data.');
      }
    };
    fetchFeed();
  }, [geocodeUrl]);

  return isLoaded && status === 200 ? (
    <>
      <div className="lodging-detail__map-header">
        {!!address && (
          <p
            className="lodging-detail__address"
            dangerouslySetInnerHTML={{ __html: address }}
          ></p>
        )}
        {!!getDirectionsLabel && mapData.formatted_address && (
          <a
            href={`${mapUrl}/${mapData.formatted_address}`}
            target="_blank"
            rel="noreferrer"
          >
            {getDirectionsLabel}
          </a>
        )}
      </div>
      <GoogleMap
        mapContainerClassName="interactive-map-module__map"
        center={{
          lat: mapData.geometry.location.lat,
          lng: mapData.geometry.location.lng
        }}
        zoom={12.5}
        options={{
          styles,
          maxZoom: 18,
          streetViewControl: false,
          ignoredPins: ['all']
        }}
      >
        <Marker
          position={{
            lat: mapData.geometry.location.lat,
            lng: mapData.geometry.location.lng
          }}
        />
      </GoogleMap>
    </>
  ) : (
    <></>
  );
};

LocationMap.propTypes = {
  mapLat: PropTypes.string,
  mapLng: PropTypes.string,
  address: PropTypes.string,
  getDirectionsLabel: PropTypes.string,
  apiKey: PropTypes.string.isRequired,
  mapUrl: PropTypes.string.isRequired,
  geocodeUrl: PropTypes.string.isRequired
};

export default LocationMap;
